var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDbsIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 6h10v8H3zM3 2h7v4H3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.354 5.146-3.5-3.5A.5.5 0 0 0 9.5 1.5h-6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-8a.5.5 0 0 0-.146-.354M10 3.206 11.793 5H10zM12.5 13.5h-9v-11H9v3a.5.5 0 0 0 .5.5h3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#191918",
  d: "M9.968 8.87a2.25 2.25 0 0 1-.314 1.577l.7.7a.5.5 0 1 1-.708.707l-.7-.7A2.253 2.253 0 1 1 9.969 8.87"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.71 8.556a1.25 1.25 0 1 0 2.08 1.388 1.25 1.25 0 0 0-2.08-1.388"
})));
export { SvgDbsIconActive as ReactComponent };
export default __webpack_public_path__ + "284bccfb338b03972365523f7e98815f.svg";